import React from "react";
import PropTypes from "prop-types";
import Toggle from "react-toggle";
import "./UserFilters.scss";

const ActiveUsersToggle = ({ disabled, is_active, onChange }) => (
  <div className="center-content">
    <span>Show Only Active Users</span>
    <Toggle
      disabled={disabled}
      name="is_active"
      onChange={onChange}
      checked={is_active}
    />
  </div>
);

ActiveUsersToggle.propTypes = {
  disabled: PropTypes.bool,
  is_active: PropTypes.bool,
  onChange: PropTypes.func
};

export default ActiveUsersToggle;
